
      var _path, _path2, _rect, _circle, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgOwnershipTransfer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 88,
  height: 88,
  viewBox: "0 0 44 45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M31 3.875c2.347 0 3.032 2.006 3.201 4.25H27.8c.169-2.244.854-4.25 3.201-4.25Z",
  stroke: "#000",
  strokeWidth: 1.6
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.75 7.71V19.5m6.5-11.79V19.5",
  stroke: "#000",
  strokeWidth: 1.6
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 22.05,
  y: 8.113,
  width: 17.9,
  height: 12.213,
  rx: 2,
  stroke: "#000",
  strokeWidth: 1.6
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11.75,
  cy: 29.75,
  r: 5.75,
  stroke: "#000",
  strokeWidth: 1.6
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 42.223C6.5 33 18 34 21 42.223",
  stroke: "#000",
  strokeWidth: 1.6,
  strokeLinecap: "round"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M33.434 27.717q.319-.315.324-.77a1.06 1.06 0 0 0-.305-.776l-2.7-2.808a.77.77 0 0 0-.556-.252.77.77 0 0 0-.563.239l-2.766 2.74a1.1 1.1 0 0 0-.342.752q-.024.438.323.794.31.32.785.325.472.006.79-.305l.71-.66a5.8 5.8 0 0 1-.39 1.805 4.4 4.4 0 0 1-1.052 1.585 4.65 4.65 0 0 1-1.607 1.034q-.898.34-1.808.328a5 5 0 0 1-.875-.081 3.8 3.8 0 0 1-.837-.255 1.04 1.04 0 0 0-.754-.009 1.18 1.18 0 0 0-.583.448q-.32.489-.152.964.17.476.693.695.593.252 1.221.365.63.112 1.225.12a7.4 7.4 0 0 0 2.686-.477 6.4 6.4 0 0 0 2.347-1.534 7.1 7.1 0 0 0 1.517-2.247q.523-1.239.574-2.503l.518.499q.313.318.766.324.456.006.811-.34M6.34 15.439q-.314.318-.311.775.001.455.317.77l2.745 2.764q.245.245.56.244a.77.77 0 0 0 .56-.248l2.72-2.786q.315-.318.33-.756.018-.438-.336-.79a1.07 1.07 0 0 0-.79-.311 1.07 1.07 0 0 0-.785.318l-.698.67a5.8 5.8 0 0 1 .36-1.81 4.4 4.4 0 0 1 1.027-1.602q.697-.703 1.59-1.06a4.9 4.9 0 0 1 1.802-.357q.455-.003.876.067.42.067.841.241.387.141.754-.003.368-.142.576-.457.313-.494.136-.967-.176-.473-.704-.683a5.7 5.7 0 0 0-1.227-.346 7.5 7.5 0 0 0-1.226-.1 7.4 7.4 0 0 0-2.678.52 6.4 6.4 0 0 0-2.322 1.572 7.1 7.1 0 0 0-1.48 2.271 7.1 7.1 0 0 0-.534 2.512l-.526-.49a1.05 1.05 0 0 0-.771-.312q-.456.002-.806.354",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"88\" height=\"88\" viewBox=\"0 0 44 45\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path clip-rule=\"evenodd\" d=\"M31 3.875c2.347 0 3.032 2.006 3.201 4.25H27.8c.169-2.244.854-4.25 3.201-4.25Z\" stroke=\"#000\" stroke-width=\"1.6\"/><path d=\"M27.75 7.71V19.5m6.5-11.79V19.5\" stroke=\"#000\" stroke-width=\"1.6\"/><rect x=\"22.05\" y=\"8.113\" width=\"17.9\" height=\"12.213\" rx=\"2\" stroke=\"#000\" stroke-width=\"1.6\"/><circle cx=\"11.75\" cy=\"29.75\" r=\"5.75\" stroke=\"#000\" stroke-width=\"1.6\"/><path d=\"M3 42.223C6.5 33 18 34 21 42.223\" stroke=\"#000\" stroke-width=\"1.6\" stroke-linecap=\"round\"/><path d=\"M33.434 27.717q.319-.315.324-.77a1.06 1.06 0 0 0-.305-.776l-2.7-2.808a.77.77 0 0 0-.556-.252.77.77 0 0 0-.563.239l-2.766 2.74a1.1 1.1 0 0 0-.342.752q-.024.438.323.794.31.32.785.325.472.006.79-.305l.71-.66a5.8 5.8 0 0 1-.39 1.805 4.4 4.4 0 0 1-1.052 1.585 4.65 4.65 0 0 1-1.607 1.034q-.898.34-1.808.328a5 5 0 0 1-.875-.081 3.8 3.8 0 0 1-.837-.255 1.04 1.04 0 0 0-.754-.009 1.18 1.18 0 0 0-.583.448q-.32.489-.152.964.17.476.693.695.593.252 1.221.365.63.112 1.225.12a7.4 7.4 0 0 0 2.686-.477 6.4 6.4 0 0 0 2.347-1.534 7.1 7.1 0 0 0 1.517-2.247q.523-1.239.574-2.503l.518.499q.313.318.766.324.456.006.811-.34M6.34 15.439q-.314.318-.311.775.001.455.317.77l2.745 2.764q.245.245.56.244a.77.77 0 0 0 .56-.248l2.72-2.786q.315-.318.33-.756.018-.438-.336-.79a1.07 1.07 0 0 0-.79-.311 1.07 1.07 0 0 0-.785.318l-.698.67a5.8 5.8 0 0 1 .36-1.81 4.4 4.4 0 0 1 1.027-1.602q.697-.703 1.59-1.06a4.9 4.9 0 0 1 1.802-.357q.455-.003.876.067.42.067.841.241.387.141.754-.003.368-.142.576-.457.313-.494.136-.967-.176-.473-.704-.683a5.7 5.7 0 0 0-1.227-.346 7.5 7.5 0 0 0-1.226-.1 7.4 7.4 0 0 0-2.678.52 6.4 6.4 0 0 0-2.322 1.572 7.1 7.1 0 0 0-1.48 2.271 7.1 7.1 0 0 0-.534 2.512l-.526-.49a1.05 1.05 0 0 0-.771-.312q-.456.002-.806.354\" fill=\"var(--theme-primary, #810ea9)\"/></svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/ownershipTransfer.5cec7ce69537e5669f4215f55df37107.svg"),
        {
          React: SvgOwnershipTransfer,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      